import { DateTime } from "luxon";
import React from "react";
import Control from "../../common/Control";
import EpItem from "./EpItem";
import EpsOfTheDay from "./EpsOfTheDay";
import { MOIS, anneesDisponibles } from "./calendrierEp";

// ============================================================
// Vue classique du calendrier des EP : le rendu historique (douze colonnes,
// vignettes EpItem, EP du jour), conservé à l'identique pour les agents qui
// préfèrent l'ancien affichage. Données et actions : useCalendrierEp.
// ============================================================
const VueClassiqueEp = ({ calendrier }) => {
  const { maintenant, eps, sectors, year, setYear, openEp, creerEp } = calendrier;
  const annees = anneesDisponibles(maintenant).map((a) => ({ id: a, name: a }));

  return (
    <div className="vue-classique-ep">
      <div className="custom-card p-2">
        <Control
          label="Année"
          type="btnList"
          btnInline
          value={year}
          datas={annees}
          change={(e) => setYear(Number(e.target.value))}
        />
      </div>
      {!sectors.length ? null : (
        <EpsOfTheDay
          eps={eps
            .filter((ep) => DateTime.fromISO(ep.beginAt).hasSame(DateTime.local(), "day"))
            .sort((a, b) => (a.beginAt < b.beginAt ? -1 : 1))}
          sectors={sectors}
          openEp={(mois, ep) => openEp(maintenant.month - 1, ep)}
        />
      )}

      <h4 className="mb-3 pt-4" style={{ fontSize: 14 }}>
        EP de toute l'année
      </h4>
      <div
        className="d-flex flex-row align-items-start justify-content-start custom-card p-0 py-2"
        style={{ minHeight: 800, height: 800 }}
      >
        {MOIS.map((mois, mk) => (
          <div
            className={`d-flex flex-fill ${mk > 0 ? "border-left" : ""} justify-content-start flex-column h-100 align-items-center px-2`}
            key={`month${mois}`}
          >
            <strong className="mb-2 text-primary">
              <i
                className={`fa fa-caret-right mr-2 text-dark animated ${
                  mk === maintenant.month - 1 && Number(year) === maintenant.year ? "fadeInLeft infinite" : "d-none"
                }`}
              />
              {mois}
            </strong>

            {!sectors.length
              ? null
              : eps
                  .filter((ep) => DateTime.fromISO(ep.beginAt).month === mk + 1)
                  .sort((a, b) => (a.beginAt < b.beginAt ? -1 : 1))
                  .map((ep) => (
                    <EpItem key={`eplist${ep.id}`} ep={ep} sectors={sectors} openEp={() => openEp(mk, ep)} />
                  ))}
            <button
              className="btn btn-sm btn-link d-center flex-wrap w-100"
              data-priv="edit_ep"
              onClick={() => creerEp(mk)}
            >
              <i style={{ fontSize: 8 }} className="fa fa-plus mr-1" />
              ajouter
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VueClassiqueEp;
